// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XRp2z","rootNoMargin":"styles_rootNoMargin__AyeyH"};